import React, {
    createContext,
    useContext,
    useState,
    useEffect,
    useRef,
} from 'react'
import { useSelector } from 'react-redux'

import { CHAT } from 'constants/socket'
import { isEmpty } from 'helpers/lodash'
import { isString } from 'helpers/miscellaneous'
import { getRoomName } from 'helpers/room'
import { getInfoFromIdentity } from 'helpers/twilio'
import useParticipants from 'hooks/useParticipants/useParticipants'
import useToggleHandler from 'hooks/useToggleHandler'
import { dispatchSendSocketMessage } from 'store/dispatcher'
import { _chatMessages } from 'store/selectors/WebSocket'

const ChatContext = createContext()

export const useChatContext = () => {
    const context = useContext(ChatContext)

    if (!context)
        throw new Error('useChatContext must be called inside ChatContext')

    return context
}

let readMessages = [] // needed to calculate the unread count

const roomName = getRoomName()

export default props => {
    const chatRef = useRef()
    const { open: isChatOpen, toggle: toggleChat } = useToggleHandler(chatRef)

    /* chat messages & unread count */
    const chatMessages = useSelector(_chatMessages)
    const [unreadCount, setUnreadCount] = useState(0)

    useEffect(() => {
        if (isChatOpen) {
            readMessages = [...chatMessages]
            setUnreadCount(0)
        } else {
            const unread = chatMessages.length - readMessages.length
            setUnreadCount(unread)
        }
    }, [chatMessages, isChatOpen])

    /* message & send  */

    const [message, setMessage] = useState('')
    const { localParticipant } = useParticipants()
    const { id: localUserId, name } = getInfoFromIdentity(
        localParticipant.identity
    )
    const sendMessage = () => {
        const isMessageNotValid =
            !message || (isString(message) && isEmpty(message.trim()))
        if (isMessageNotValid) return
        dispatchSendSocketMessage({
            name,
            message,
            user_id: localUserId,
            action: CHAT,
            room: roomName,
        })
        setMessage('')
    }

    const value = {
        chatRef,
        message,
        setMessage,
        sendMessage,
        isChatOpen,
        toggleChat,
        localUserId,
        unreadCount,
        chatMessages,
    }

    return <ChatContext.Provider value={value} {...props} />
}
